import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;
